<template>
	<div class="invite">
		<el-card v-show="adding">
			<div slot="header">
				<strong>Invite New Assistant</strong><br>
				<small>
					A medical assistant can schedule patients and send messages on your behalf.
					DoctorPlan will send an invitation email to the medical assistant at the email
					address you provide below.
				</small>
			</div>
			<el-input v-model="name" ref="name" placeholder="Assistant's Full Name"></el-input>
			<label v-if="nameError" class="error">{{ nameError }}</label>
			<el-input v-model="email" ref="email" placeholder="Email address of assistant"></el-input>
			<label v-if="emailError" class="error">{{ emailError }}</label>

			<div class="action">
				<!-- Cancel button closes the form -->
				<el-button type="link" plain @click="finishAdd">Cancel</el-button>

				<el-button
					v-bind:disabled="invitingAssistant"
					@click="invite"
					type="primary">
					<i v-if="invitingAssistant" class="el-icon-loading"></i>
					<span v-if="invitingAssistant">
						Sending Invitation...
					</span>
					<span v-else>
						Add Assistant
					</span>
				</el-button>
			</div>
		</el-card>

		<el-button v-show="!adding" class="add-button" type="link" plain
			@click="startAdd">
			<i class="el-icon-plus"></i> Add Medical Assistant
		</el-button>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	name: 'invite-assistant-card',

	data() {
		return {
			adding: false,
			name: '',
			email: '',
			error: null
		}
	},

	methods: {
		...mapActions('provider', [
			'inviteAssistant'
		]),
		startAdd() {
			this.adding = true
			setTimeout(() => {
				this.$refs.name.focus()
			}, 100)
		},
		finishAdd() {
			this.adding = false
			this.error = null
		},
		invite() {
			this.inviteAssistant({
				name: this.name,
				email: this.email
			})
			.then(() => {
				this.adding = false
			})
			.catch((error) => {
				this.error = error
				if (error.code == 'InvalidName')
					this.$refs.name.focus()
				else
					this.$refs.email.focus()
			})
		}
	},

	computed: {
		...mapState('provider', [
			'invitingAssistant'
		]),

		nameError() {
			if (this.error && this.error.code == 'InvalidName')
				return 'First and last name required'

			return null
		},

		emailError() {
			if (this.error) {
				if (this.error.code == 'UserExists')
					return 'Email address already in use'
				if (this.error.code == 'InvalidEmail')
					return 'Invalid email address'
			}
			return null
		}
	}
}
</script>

<style lang="scss" scoped>
$danger-color: #da4e4e;
.el-input {
	margin-top: 5px;
	margin-bottom: 5px;
}
.add-button {
	width:100%;
	text-align:center;
	background:none;
	border:dashed 2px #dfdfdf;
	color: #5f5f5f;
}
.invite {
	label {
		display: block;
		color: $danger-color;
		font-weight: 700;
		font-size: 14px;
		line-height: 20px;
		padding-left: 15px;
	}
}
.action {
	padding-top: 10px;
	text-align:right;

	.el-button--primary {
		font-weight: 700;

		i {
			float: left;
			margin: 0 10px 0 -5px;
		}
	}
}
</style>
